import { Component, OnInit, Input } from '@angular/core';
import { StatusbarComponent } from '../../menu/statusbar/statusbar.component';
import { MenuService } from '../../../../services/menu.service';
import { DataIoService } from '../../../../services/data-io.service';
import { ConfigService } from '../../../../services/config.service';
import { MenuNode,SensorSet,BaseSensor } from '../../../../classes';
import { TranslationService } from '../../../../services/translation.service';

@Component({
	selector: 'screen-idle',
	templateUrl: './idle.component.html',
	styleUrls: ['./idle.component.scss']
})
export class IdleComponent implements OnInit {
	@Input('debug') debug:boolean=false;
	_unit:string ="STD_UNIT_CELSIUS_NORMAL_LEFT";
	_value:string="22.0";
	get value(){
		return this.indoorTempSensor.getCurrentValue();
	}
	get unit(){
		return this.indoorTempSensor.getUnit();	
	}

	outdoorTempSensor:BaseSensor;
	indoorTempSensor:BaseSensor;
	humiditySensor:BaseSensor;
	desiredTemp:BaseSensor;
	hasOutdoorTempSensor:boolean=true;
	hasHumiditySensor:boolean=true;
	
		
	get serviceCompany():string{
		if(this.ioService.getContactName() && this.ioService.getContactName().length > 0){
			return this.ioService.getContactName();
		}else{
			return this.translator.tr('OTX_MAINTENANCE_3_STANDARD_NAME');
		}
	}	
	get servicePhoneNumber():string{
		return this.ioService.getContactPhone();
		
	}
	getTranslator():TranslationService{
		return this.translator;
	}
	getIoService():DataIoService{
		return this.ioService;
	}
	constructor(private menuService: MenuService, private ioService: DataIoService, private config: ConfigService, private translator: TranslationService ) { 
		this.hasOutdoorTempSensor = (this.ioService.getConfiguration().simulatorConfig.has('outdoor-temperature-sensor'));
		this.hasHumiditySensor = (this.ioService.getConfiguration().simulatorConfig.has('humidity-sensor'));
		this.outdoorTempSensor = this.ioService.sensors.getTemperatureSensor('outdoor');
		this.indoorTempSensor = this.ioService.sensors.getTemperatureSensor('room_temperature');
		this.desiredTemp = this.ioService.getCurrentNominalTemperatureSensor();
		this.humiditySensor = this.ioService.sensors.getHumiditySensor('humidity');
	}
	eventSubscription: any;
	ngOnInit() {
		this.debugOut("OnInit");
		this.eventSubscription = this.ioService.inputs.events$.subscribe(
      		(event)=>{this.eventHandler(event);}
      	);
	}
	serviceDateExpired(){
		return this.ioService.serviceDateExpired();
	}
	ngOnDestroy(){
		this.debugOut("onDestroy");
		this.eventSubscription.unsubscribe();
	}	

	debugOut(msg:string):void{
		if(this.debug){
			console.log("IdleComponent: "+msg);
		}
	}

	eventHandler(event){
		this.debugOut("Handling Event: "+event);
		switch(event){
			case 'down':{
				break;
			}
			case 'up':{
				
				break;
			}
			case 'confirm':{
				
				break;
			}
			case 'menu':{
				this.menuService.goto('dashboard');
				break;
			}
			case 'back':{
				break;
			}
			default:{

			}
		}
	}
}
